<template>
  <span>
    <span @click.stop="open">
      <slot></slot>
    </span>
    <el-dialog append-to-body :title="title" top="15vh" :visible="dialogVisible" width="400px" @close="close">
      <div class="dialog-wrap" style="padding-top: 10px;">
        <login v-if="type =='login'" @confirm="confirm" @change="type = 'register',title = '注册账号'" />
        <register v-else @confirm="confirm" @change="type = 'login',title = '请先登录'" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" size="mini">关闭</el-button>
      </div>
    </el-dialog>
  </span>
</template> 
<script>
import login from './components/login'
import register from './components/register'

export default {
  name: '',
  components: { login, register },
  props: {},
  data() {
    return {
      dialogVisible: false,
      title: '请先登录',
      type: 'login'
    }
  },
  computed: {},
  created() {},

  methods: {
    close() {
      this.dialogVisible = false
      this.$emit('close')
    },
    confirm(userInfo) {
      this.dialogVisible = false
      this.$emit('confirm', userInfo)
    },
    open() {
      this.dialogVisible = true
    },
    handleSave() {
      this.$refs.versionForm.handleSave()
    }
  }
}
</script>
          
    <style lang="scss" >
</style>
          